
import type { SVGProps } from 'react';
const SvgExpandLess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#expand-less_svg__a)">
      <path fill="#263E6A" d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    </g>
    <defs>
      <clipPath id="expand-less_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExpandLess;
